import React, { useEffect, useMemo, useRef } from "react";
import $ from "jquery";
import "magnific-popup";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

export default function GalleryMini({ images, imageAlt = "" }) {
  const galleryRef = useRef(null);
  const currentPath = window.location.pathname;
  let folderName = "";
  let length = 0;
  let padLength = 0;
  if (currentPath.includes("capital-plaza")) {
    folderName = "capital-plaza";
    length = 27;
    padLength = 2;
  } else if (currentPath.includes("podgorica")) {
    folderName = "podgorica";
    length = 16;
  } else if (currentPath.includes("porto-montenegro")) {
    folderName = "porto-montenegro";
    length = 12;
  }

  const imageSrcList = useMemo(() => images || Array.from(
    { length: length },
    (_, i) => {
      const imageIndex = i + 1;
      const fileName = padLength
        ? String(imageIndex).padStart(padLength, "0")
        : String(imageIndex);
      return `/assets/images/gallery/${folderName}/${fileName}.jpg`;
    }
  ), [images, folderName, length, padLength]);

  useEffect(() => {
    let galleryItems = imageSrcList.map(img => {
      return { src: img };
    });
  
    const gallery = $(galleryRef.current);
    gallery.on("click.galleryMini", "a.image-popup", function(e) {
      e.preventDefault();
      let startIndex = imageSrcList.indexOf($(this).attr("href"));
      $.magnificPopup.open({
        items: galleryItems,
        type: "image",
        gallery: {
          enabled: true
        },
        index: startIndex,
        callbacks: {
          beforeOpen: function() {
            this.st.image.markup = this.st.image.markup.replace(
              "mfp-figure",
              "mfp-figure animated zoomInDown"
            );
          }
        }
      });
    });
  
    return () => {
      // Destruct MagnificPopup when the component is unmounted.
      $.magnificPopup.close();
      gallery.off(".galleryMini");
    };
  }, [imageSrcList]);
  
  
  

  return (
    <div className="row" ref={galleryRef}>
      <OwlCarousel
        className="rs-carousel owl-carousel"
        loop={true}
        items={3}
        margin={30}
        autoplay={true}
        autoplayHoverPause={true}
        autoplayTimeout={5000}
        smartSpeed={800}
        dots={true}
        nav={false}
        navSpeed={false}
        center={false}
        navText={["<i className='flaticon-left-arrow'></i>","<i className='flaticon-right-arrow'></i>"]}
        responsive={{
          0: { items: 1, nav: false, dots: true, center: false },
          768: { items: 2, nav: false, dots: true, center: false },
          992: { items: 2, nav: false, dots: true, center: false },
          1200: { items: 3, nav: false, dots: true, center: false },
        }}
      >
        {imageSrcList.map((img, index) => (
          <div key={img} className="">
            <div className="gallery-item">
              <div className="gallery-icon">
                <a className="image-popup" href={img}>
                  <img src={img} alt={imageAlt ? `${imageAlt} — ${index + 1}` : ""} loading="lazy" decoding="async" />
                </a>
              </div>
            </div>
          </div>
        ))}
      </OwlCarousel>
    </div>
  );
}
